import { auth } from "@/lib/firebase.ts";
import { useUserStore } from "@/lib/stores/userStore";
import {
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
  User,
} from "firebase/auth";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useUser } from "./useUser";
import { handleReferralCode } from "@/lib/utils/referral";

export function useAuth() {
  //  TODO rewrite to zustand store and subscribe to user from firestrore
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(true);
  const provider = new GoogleAuthProvider();
  const login = () =>
    signInWithPopup(auth, provider)
      .then((result) => {
        const user = result.user;
        if (user) {
          setUser(user);
        }
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });

  const logout = () => {
    auth
      .signOut()
      .then(() => {
        // Clear React Query cache
        queryClient.setQueryData<User>(["user"], undefined);
        queryClient.removeQueries({ queryKey: ["user"] });

        // Clear Zustand store
        setUserStore(null);
        useUserStore.getState().clearUser();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const { data: user } = useQuery<User | null>({
    queryKey: ["user"],
    queryFn: () => null,
    enabled: false,
  });

  const { setUser: setUserStore } = useUserStore();
  const { user: sfUser } = useUser(user?.uid);

  const setUser = useCallback(
    (user: User | null) => {
      queryClient.setQueryData<User>(["user"], user || undefined);
      setUserStore(user ? sfUser : null);
    },
    [queryClient, setUserStore, sfUser],
  );

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoading(false);
      setUser(user);
      if (user?.email) {
        handleReferralCode(user.uid).catch(console.error);
      }
    });
    return () => unsubscribe();
  }, [setUser]);
  return { user, setUser, login, logout, isLoading };
}
